import React, { useEffect, useState } from "react";

interface CardTitleProps {
  card: { title: string };
  index: number;
}

const IpadCardTitle: React.FC<CardTitleProps> = ({ card }) => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkTablet = () => {
      const ua = navigator.userAgent || navigator.vendor || "";

      // Detect iPads (all versions, iPadOS >=13 too)
      const isIpad =
        /iPad/.test(ua) || (/Macintosh/.test(ua) && "ontouchend" in document);

      // Detect Android tablets: has "Android" but NOT "Mobile"
      const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

      // Width-based fallback (generic tablets between 768px–1366px)
      const width = window.innerWidth;
      const isGenericTablet = width >= 768 && width <= 1366;

      setIsTablet(isIpad || isAndroidTablet || isGenericTablet);
    };

    checkTablet();
    window.addEventListener("resize", checkTablet);
    return () => window.removeEventListener("resize", checkTablet);
  }, []);

  return (
    <p
      className={`
        absolute inset-0 flex items-center justify-center
        text-primary-text text-heading-6 leading-relaxed
        transition-all duration-500 ease-out
        ${isTablet
        ?
          // Tablet styles: always visible, with margin
          "opacity-100 translate-y-0 mx-[16px] my-[30px]"
        :
          // Non-tablet styles: animate on hover at xl, responsive margins
          "md:opacity-100 md:translate-y-0 xl:opacity-0 xl:translate-y-4 xl:group-hover:opacity-100 xl:group-hover:translate-y-0 md:mx-[16px] md:my-[30px] lg:mx-[16px] lg:my-[30px] xl:mx-0 xl:my-0 max-[1365px]:mx-[16px] max-[1365px]:my-[30px]"
        }
      `}
    >
      {card.title}
    </p>
  );
};

export default IpadCardTitle;
